<template>
    <div class="flex flex-row w-full">
        <div class="flex items-center w-full">
          <img :src="url" alt="foto profilo"
          class="rounded-l-lg w-20 h-20">
          <div class="flex justify-center text-left bg-white h-20 rounded-r-lg w-full">
            <div class="flex flex-col justify-center items-center divide-y
              divide-grey-academy-200 mx-4 w-full">
              <h1 class="text-md self-center pb-1 flex justify-center w-full">
                {{ userName }}</h1>
              <stars-rate :starsAvg="starsAvg" class="justify-center pt-2 w-full"
                starsClass="w-5 pl-1"  />
            </div>
            <h1 class="text-lg md:self-start mx-3 pt-1">
              {{ userType }}
            </h1>
          </div>
        </div>
    </div>
</template>

<script>
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import StarsRate from './graphics/StarsRate.vue';

export default {
  components: { StarsRate },
  props: {
    userName: String,
    userType: String,
    urlPhoto: String,
    starsAvg: Number,
  },

  computed: {
    url() {
      return this.urlPhoto ? this.urlPhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png';
    },
  },

  mixins: [StreamFunctionsMixin],

};
</script>
